import { useMutation } from "react-query";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface UseCompleteOnboardingProps {
  onError?: (error: unknown) => void;
  onSuccess?: () => void;
}

export const useCompleteOnboarding = ({
  onSuccess,
  onError,
}: UseCompleteOnboardingProps = {}) =>
  useMutation({
    mutationFn: () =>
      reactQueryPatch(internalApi.helpWidget.completeOnboarding()),
    onSuccess,
    onError,
  });
